module.exports = __webpack_public_path__ + "img/image5.da3c8198.jpg";